import React, { useState, useEffect } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import './filterModel.css';

function FilterModel({
  show,
  handleClose,
  onFilterApply,
  accountOptions = ['All'],
  typeOptions = ['All', 'Debit', 'Payment', 'Credit'],
}) {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [type, setType] = useState('All');
  const [accounts, setAccounts] = useState(['All']);
  const [format, setFormat] = useState('On Screen');
  // Reset / sync when modal opens
  useEffect(() => {
    if (show) {
      if (!startDate && !endDate) {
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        const fmt = (d) =>
          `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
            d.getDate()
          ).padStart(2, '0')}`;

        setStartDate(fmt(firstDay));
        setEndDate(fmt(lastDay));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const handleAccountChange = (e) => {
    const options = Array.from(e.target.selectedOptions, (option) => option.value);
    setAccounts(options);
  };

  const applyFilter = () => {
    const filterData = {
      startDate,
      endDate,
      type,
      accounts,
      format, // "On Screen" | "PDF" | "Excel" | "CSV"
    };

    if (onFilterApply) {
      onFilterApply(filterData);
    }

    handleClose();
  };

  const resetFilter = () => {
    setStartDate('');
    setEndDate('');
    setType('All');
    setAccounts(['All']);
    setFormat('On Screen');

    if (onFilterApply) {
      onFilterApply({});
    }

    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      {/* Top Header */}
      <Modal.Header
        className="filter-modal-header"
        closeButton
        closeVariant="white"
      >
        <Modal.Title className="filter-header-title">Filter</Modal.Title>
      </Modal.Header>

      {/* Main Body */}
      <Modal.Body className="filter-modal-body">
        {/* Title & Underline */}
        <h4 className="filter-modal-title">Parameters</h4>

        <div className="filter-title-border"></div>

        {/* Inner Grey Box */}
        <div className="filter-grey-box">
          <Form>
            {/* Start Date */}
            <div className="filter-form-group">
              <Form.Label className="filter-form-label">
                Start Date <span className="required-star">*</span>
              </Form.Label>

              <Form.Control
                className="filter-form-control"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>

            {/* End Date */}
            <div className="filter-form-group">
              <Form.Label className="filter-form-label">
                End Date <span className="required-star">*</span>
              </Form.Label>

              <Form.Control
                className="filter-form-control"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>

            {/* Type Dropdown */}
            <div className="filter-form-group">
              <Form.Label className="filter-form-label">
                Type <span className="required-star">*</span>
              </Form.Label>

              <Form.Select
                className="filter-form-control filter-select-control"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                {typeOptions.map((t, index) => (
                  <option key={index} value={t}>
                    {t}
                  </option>
                ))}
              </Form.Select>
            </div>

            {/* Accounts List Box */}
            <div className="filter-form-group filter-account-group">
              <Form.Label className="filter-form-label">Accounts</Form.Label>

              <Form.Control
                className="filter-account-control"
                as="select"
                multiple
                value={accounts}
                onChange={handleAccountChange}
              >
                {accountOptions.map((acc, index) => (
                  <option key={index} value={acc}>
                    {acc}
                  </option>
                ))}
              </Form.Control>
            </div>

            {/* Format Dropdown */}
            <div className="filter-form-group filter-last-group">
              <Form.Label className="filter-form-label">
                Format <span className="required-star">*</span>
              </Form.Label>

              <Form.Select
                className="filter-form-control filter-select-control"
                value={format}
                onChange={(e) => setFormat(e.target.value)}
              >
                <option value="On Screen">On Screen</option>
                <option value="PDF">PDF</option>
                <option value="Excel">Excel</option>
                <option value="CSV">CSV</option>
              </Form.Select>
            </div>
          </Form>
        </div>

        {/* Buttons */}
        <div className="filter-button-container">
          <Button className="filter-btn" onClick={applyFilter}>
            Filter
          </Button>

          <Button className="filter-btn" onClick={resetFilter}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default FilterModel;